import React from 'react'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import CheckIcon from '@material-ui/icons/Check';
import SearchIcon from '@material-ui/icons/Search';
import ErrorIcon from '@material-ui/icons/Error';
import withRoot from '../../withRoot';

import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';

const styles = theme => ({
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonFailure: {
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  }
});

const TerminalCodeInput = ({handleGetTerminal, terminalCodeInputValue, handleTerminalValueChange, terminal, classes}) => {
  
  const buttonClassname = classNames({
    [classes.buttonSuccess]: Boolean(terminal.terminalData),
    [classes.buttonFailure]: terminal.hasFailed,
  });

  return (
    <Grid container >
      <Grid item>
        <TextField
          required
          autoFocus
          value={terminalCodeInputValue}
          id="terminalCodeInput"
          label="Terminaalin koodi"
          margin="dense"
          onChange={handleTerminalValueChange}/>
      </Grid>
      <Grid item>
        <div className={classes.wrapper}>
          <Button
            variant="fab"
            color="primary"
            className={buttonClassname}
            onClick={() => handleGetTerminal(terminalCodeInputValue)} >
            {!terminal.terminalData && !terminal.hasFailed && <SearchIcon />}
            {terminal.terminalData && <CheckIcon />}
            {terminal.hasFailed && <ErrorIcon />}
          </Button>
          {terminal.isLoading && <CircularProgress size={68} className={classes.fabProgress} />}
        </div>
      </Grid>
    </Grid>
  )
}

export default withRoot(withStyles(styles)(TerminalCodeInput));



// WEBPACK FOOTER //
// ./src/components/Steps/TerminalCodeInput.js